import Router from 'next/router';

import CloseIcon from '@mui/icons-material/Close';
import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'next-i18next';
import { setConfirmEmailRedirectCookie } from 'src/helpers/auth';
import { ROUTES } from 'src/helpers/constants';

import FontAwesomeIcon from '@components/atoms/fontAwesomeIcon';

type Props = {
  dialog: any;
  citizenId: string | undefined;
  redirectUrl?: string;
  hideCloseButton?: boolean;
};

const ConfirmEmailModal = ({ dialog, citizenId = '', redirectUrl = '', hideCloseButton }: Props) => {
  const { t } = useTranslation('common');
  const theme = useTheme();
  const onClick = () => {
    setConfirmEmailRedirectCookie(redirectUrl);
    Router.push(ROUTES.MERGE_USER);
  };

  return (
    <Box sx={{ p: '16px' }}>
      <Box sx={{ position: 'absolute', top: 10, right: 10 }}>
        {!hideCloseButton && (
          <IconButton onClick={dialog.close}>
            <CloseIcon />
          </IconButton>
        )}
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'column', rowGap: 1 }}>
        <FontAwesomeIcon
          style={{ fontSize: '50px' }}
          color={theme.palette.grey[500]}
          icon="fa-light fa-circle-exclamation"
        />
        <Typography color="primary.main" variant="h3">
          {t('confirm_email.modal.title')}
        </Typography>
        <Typography sx={{ fontFamily: 'Lanna', textAlign: 'center' }} variant="body1">
          {t('confirm_email.modal.subtitle1')} {citizenId}
          <br />
          {t('confirm_email.modal.subtitle2')}
          <br />
          {t('confirm_email.modal.subtitle3')}
        </Typography>
        <Button onClick={onClick} sx={{ mt: '6px', width: '120px' }} variant="contained" color="primary">
          {t('confirm_email.modal.button')}
        </Button>
      </Box>
    </Box>
  );
};

export default ConfirmEmailModal;
